<template>
  <OrderList></OrderList>
</template>
<script>

import OrderList from './list'
export default {
  name: 'ArchiveOrderList',
  components: {
    OrderList
  },
  data() {
    return {}
  },
  computed: {

  },
  methods: {},
  mounted() { }
}
</script>
<style scoped lang="css">
</style>
